import React, { useMemo } from 'react';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import styles from './KPITypeSelect.module.css';

function KPITypeSelect({ value, options, onChange, onSelect }) {
  const { byLabel, byValue } = useMemo(
    () =>
      options.reduce(
        (acc, option) => {
          acc.byLabel[option.label] = option;
          acc.byValue[option.value] = option;

          return acc;
        },
        { byLabel: {}, byValue: {} }
      ),
    [options]
  );
  const selectedOption = byValue[value.key];
  const handleSelect = (label) => {
    const option = byLabel[label];

    if (option) {
      onChange(onSelect(option));
    }
  };

  return (
    <div className={styles.root}>
      <Dropdown
        className={styles.dropdown}
        keyRef={true}
        showItems={6}
        selectItem={handleSelect}
        title={selectedOption?.label}
        data={options}
        overflowEllipsis={true}
        kpiSearch={true}
      />
    </div>
  );
}

export default KPITypeSelect;
